








import {
  defineComponent, useContext, useFetch, ref,
} from '@nuxtjs/composition-api';
import SfBreadcrumbs from './SfBreadcrumbs.vue';
import { useUiHelpers } from '~/composables';
import { useTraverseCategory } from '~/modules/catalog/category/helpers/useTraverseCategory';
import { Breadcrumb } from '~/modules/catalog/types';

export default defineComponent({
  components: { SfBreadcrumbs },
  head() {
    const BreadcrumbsItems = (this.breadcrumbs as Breadcrumb[]).map((breadcrumb: Breadcrumb, index: number) => {
      return {
        "@type": "ListItem",
        "position": index + 1,
        "item": {
          "@id": breadcrumb.link,
          "name": breadcrumb.text
        }
      }
    })
    return {
      script: [
        {
          hid: 'ld-breadcrumbs',
          type: 'application/ld+json',
          json: {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": BreadcrumbsItems
          }
        }
      ]
    }
  },
  setup() {
    const { getCatLink } = useUiHelpers();
    const { localePath, $config } = useContext();

    const {
      categoryAncestors, isCategoryTreeLoaded, loadCategoryTree,
    } = useTraverseCategory();
    const breadcrumbs = ref<Breadcrumb[]>([]);

    useFetch(async () => {
      if (!isCategoryTreeLoaded.value) {
        await loadCategoryTree();
      }

      breadcrumbs.value = categoryAncestors.value.map((category, index) => ({
        text: category.name,
        link: index<categoryAncestors.value.length-1 ? `${$config.soleproDomain}${localePath(getCatLink(category))}` : 'javascript:void(0)',
      }))

      breadcrumbs.value.unshift({
        text: 'Home',
        link: `${$config.soleproDomain}${localePath('/')}`,
      });

    });

    return {
      breadcrumbs,
    };
  },
});
